/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, TenantId, uuid } from '@src/app/model/abstract-object';
import { DefaultBCode } from '@src/app/model/bcode';
import { Period } from '@src/app/model/period';
import { User } from '@src/app/model/user';
export class Team extends AbstractObject {
    constructor(o: Partial<Team> = {}) {
        super(o);
    }
    id: TenantId;
    legalName: string;
    defaultAddress: string;

    users?: User[];

    currentPeriod?: Period;

    primaryAgentId?: uuid;
    primaryAgentName?: string;

    defaultBCodes: DefaultBCode[];
}


